import React from 'react';
import { Sparkles } from 'lucide-react';

const AICEResponse = () => {
    return (
        <div className="mt-2 bg-gradient-to-r from-blue-600 to-indigo-600 rounded-3xl p-8 text-white">
            <div className="flex items-start gap-4">
                <Sparkles className="w-8 h-8 flex-shrink-0 mt-1" />
                <div>
                    <h3 className="text-2xl font-bold mb-3">Our Response</h3>
                    <p className="text-blue-50 leading-relaxed mb-4">
                        AICE-Africa responds directly to these continental needs by:
                    </p>
                    <ul className="text-blue-50 text-lg leading-relaxed space-y-3">
                        <li className="flex items-start gap-2">
                            <span className="text-blue-200 mt-1">•</span>
                            <span>Providing minimum compute and data infrastructure accessible to both public and private institutions in Africa.</span>
                        </li>
                        <li className="flex items-start gap-2">
                            <span className="text-blue-200 mt-1">•</span>
                            <span>Supporting the development of multilingual, inclusive AI models that reflect African cultures, languages, and socioeconomic contexts.</span>
                        </li>
                        <li className="flex items-start gap-2">
                            <span className="text-blue-200 mt-1">•</span>
                            <span>Assisting governments and institutions to collect, curate, and maintain quality data based on FAIR principles for key domains such as agriculture, health, climate resilience, and education.</span>
                        </li>
                        <li className="flex items-start gap-2">
                            <span className="text-blue-200 mt-1">•</span>
                            <span>Promoting the use of open-source AI models and shared resources to reduce duplication, accelerate innovation, and empower local innovators in low-resource settings.</span>
                        </li>
                        <li className="flex items-start gap-2">
                            <span className="text-blue-200 mt-1">•</span>
                            <span>Offering AI training programs, professional certifications, and workforce skilling across the AI value chain.</span>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default AICEResponse;